/** The first reads of a page, started together as the app loads (17.10.2026: «Аналитика» waited for /api/auth/state, then
 * /api/calendar/bootstrap, then /api/app/bootstrap one after another — three round trips — and only then for its own code
 * and numbers). Each provider takes its read from here once instead of starting it; a read that failed (say, the
 * session was not there yet) is simply made again by the provider, so nothing changes for a page but the waiting. */
export type StartupKey = "auth" | "calendar" | "bootstrap" | "calendar-scope-bootstrap" | "workspace" | "dialogs-workspace";

const started = new Map<StartupKey, Promise<unknown>>();
/** A read nobody took (the page went elsewhere) is not kept: the next one must be fresh. */
const KEEP_MS = 30_000;

export function startRead<T>(key: StartupKey, read: () => Promise<T>) {
  if (started.has(key)) return;
  const answer = read();
  answer.catch(() => undefined);
  started.set(key, answer);
  setTimeout(() => { if (started.get(key) === answer) started.delete(key); }, KEEP_MS);
}

/** The read started at load, once; else (or when it failed) a fresh one. */
export function takeRead<T>(key: StartupKey, read: () => Promise<T>): Promise<T> {
  const early = started.get(key) as Promise<T> | undefined;
  if (!early) return read();
  started.delete(key);
  return early.catch(() => read());
}

/** Only for tests. */
export function forgetReads() { started.clear(); }
